export const NAME = 'inkjetElements';
